import { Helmet } from 'react-helmet-async';
import { HeaderAuth } from '../../../layouts/Auth';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import clsx from 'clsx';
import { VuiButton } from '../../../vodea/@vodea-ui/components/VuiButton';
import { useState } from '@hookstate/core/dist';
import { useTranslation } from 'react-i18next';
import { Inputs, schema } from './validation';
import AuthenticationRepository from '../../../repositories/AuthenticationRepository';
import { AxiosResponse, AxiosError } from 'axios';
import useIsMounted from '../../../vodea/utilities/hooks/useIsMounted';
import { mapHookErrors, showToast } from '../../../vodea/utilities/helpers/global';

const url = () => process.env.REACT_APP_URL;

const ForgotPassword: React.FC<any> = () => {
  const { t } = useTranslation();
  const loading = useState(false);
  const isMounted = useIsMounted();

  const { register, handleSubmit, errors, setError } = useForm<Inputs>({
    resolver: yupResolver(schema)
  });
  const onSubmit = handleSubmit(data => {
    loading.set(true);

    AuthenticationRepository.forgotPassword({
      email: data.email,
      url: url() + '/auth/reset-password'
    })
      .then((response: AxiosResponse) => {
        showToast('Success, reset link has send to your email', 'success');

        loading.set(false);
      })
      .catch((e: AxiosError) => {
        const data = e?.response?.data.data;

        if (isMounted.current && !data.success) {
          showToast(data.message, 'error');
        }

        loading.set(false);
      });
  });

  return (
    <>
      <Helmet>
        <title>{t('forgotPassword.title')}</title>
      </Helmet>
      <HeaderAuth title={t('forgotPassword.header.0')} subtitle={t('forgotPassword.header.1')} />
      <form className={'form-wrapper'} onSubmit={onSubmit}>
        <div
          className={clsx({
            'form-group mb-4': true,
            error: errors.email
          })}
        >
          <label className={'form-label'}>{t('form.email.label')}</label>
          <input type='text' name={'email'} className='form-control' ref={register} />
          <label className={'label-help'}>{errors.email?.message}</label>
        </div>

        <VuiButton label={t('button.sendResetPasswordLink')} loading={loading.get()} forSubmit={true} fullWidth={true} />

        <hr className={'separator'} />

        <p>
          {t('forgotPassword.rememberPassword')}? <Link to={'/auth/login'}> {t('forgotPassword.signIn')}</Link>
        </p>
      </form>
    </>
  );
};

export default ForgotPassword;
